import { Injectable } from '@angular/core';
import {Modal, ModalController} from "ionic-angular";

@Injectable()
export class ModalProvider {

  private modal: Modal;
  constructor(private modalCtrl: ModalController) {}

  create(page: string, params = undefined, config = undefined) {
    this.dismiss();

    this.modal = this.modalCtrl.create(page, params, config);

    return this.modal;
  }

  dismiss() {
    if(this.modal) {
      this.modal.dismiss().catch(()=>{
        return[];
      });
      this.modal = undefined;
    }
  }

}



// WEBPACK FOOTER //
// ./src/providers/modal/modal.ts